import { render, staticRenderFns } from "./ServerErrorModal.vue?vue&type=template&id=280483ee&scoped=true"
import script from "./ServerErrorModal.vue?vue&type=script&lang=js"
export * from "./ServerErrorModal.vue?vue&type=script&lang=js"
import style0 from "./ServerErrorModal.vue?vue&type=style&index=0&id=280483ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280483ee",
  null
  
)

export default component.exports